/**
 * Gu00fcvenli u00e7erez yu00f6netimi iu00e7in yardu0131mcu0131 fonksiyonlar
 */

/**
 * Gu00fcvenli bir u015fekilde u00e7erez deu011ferini u015fifreler
 * @param {string} value - u015eifrelenecek deu011fer
 * @returns {string} u015eifrelenmiu015f deu011fer
 */
export const encryptValue = (value) => {
  // Basit bir u015fifreleme yu00f6ntemi (production iu00e7in daha gu00fcu00e7lu00fc bir u015fifreleme kullanu0131lmalu0131du0131r)
  return btoa(value); // Base64 encoding
};

/**
 * u015eifrelenmiu015f u00e7erez deu011ferini u00e7u00f6zer
 * @param {string} encryptedValue - u015eifrelenmiu015f deu011fer
 * @returns {string} u00c7u00f6zu00fclmu00fcu015f deu011fer
 */
export const decryptValue = (encryptedValue) => {
  if (!encryptedValue) return null;
  try {
    return atob(encryptedValue); // Base64 decoding
  } catch (error) {
    console.error('u00c7erez deu011feri u00e7u00f6zu00fclemedi:', error);
    return null;
  }
};

/**
 * Gu00fcvenli bir u015fekilde localStorage'a veri kaydeder
 * @param {string} key - Anahtar
 * @param {string} value - Deu011fer
 */
export const setSecureStorage = (key, value) => {
  try {
    const encryptedValue = encryptValue(value);
    localStorage.setItem(key, encryptedValue);
  } catch (error) {
    console.error('Veri kaydedilemedi:', error);
  }
};

/**
 * localStorage'dan gu00fcvenli bir u015fekilde veri okur
 * @param {string} key - Anahtar
 * @returns {string|null} Deu011fer veya null
 */
export const getSecureStorage = (key) => {
  try {
    const encryptedValue = localStorage.getItem(key);
    return decryptValue(encryptedValue);
  } catch (error) {
    console.error('Veri okunamadu0131:', error);
    return null;
  }
};

/**
 * localStorage'dan veriyi gu00fcvenli bir u015fekilde siler
 * @param {string} key - Anahtar
 */
export const removeSecureStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error('Veri silinemedi:', error);
  }
};
